/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Wizard_Uno_Message_NamedInputs */



/**
* | output |
* | --- |
* | "I want to create a new agent called \"{name}\". Ask me what it should do and set it up for me." |
*
* @param {Agent_Wizard_Uno_Message_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_uno_message_named = /** @type {((inputs: Agent_Wizard_Uno_Message_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Uno_Message_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ich möchte einen neuen Agenten namens „${i?.name}“ erstellen. Fragen Sie mich, was er tun soll, und richten Sie ihn für mich ein.`)
	return /** @type {LocalizedString} */ (`I want to create a new agent called "${i?.name}". Ask me what it should do and set it up for me.`)
});